const comp = [
    {
      question:
        "When will the problem statements be released?",
      answer:
        " Problem Statements for each domain will be released on 26th February 2024.",
    },
    {
        question:
          "What will be the mode of hackathon?",
        answer:
          "Hackathon will be in Online mode.",
      },
      {
        question:
          "What are the eligibility criteria? Are there any prerequisites?",
        answer:
          "This hackathon is open to all University students of all branches. While experience and software development is beneficial !",
      },
      {
        question:
          "How many team members are allowed in one team for this Hackathon?",
        answer:
          "Team size is 1-4 members",
      },
      {
        question:
          "What is the registration fees?",
        answer:
          "There is no registration fees.",
      },
      {
        question:
          "What is the format of pitch deck?",
        answer:
          <>The pitch deck should be submitted in PDF format. And slides should be imported from here - <a href="https://docs.google.com/presentation/d/1DLwJ74YDoaaEbosAsZDgRRdKVc1l4pqikVoZ3ns_-fo/edit?usp=drivesdk" target="_blank" style={{textDecorationLine:"underline"}}>CLICK HERE</a></>,
      },      
    
  ];
  
  export default comp;
  